import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faLock,
  faUsersGear,
  faPlus,
  faEye,
  faEyeSlash,
  faEdit,
  faTrash,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { configData } from "../config";
import "./classes/Main.css";
import "./classes/ManageUsers.css";
import Pagination from "./Pagination";

const API_BASE = configData.APP_URL;

const ManageUsers = () => {
  const mockdata = [
  {
    id: 1,
    username: "admin",
    role: "1",
    role_name: "admin",
    created_at: "2025-02-10T09:30:00Z",
  },
  {
    user_id: 2,
    user_name: "sales_user",
    role: "2",
    role_name: "cashier",
    created: "2025-02-12T14:45:00Z",
  },
  {
    id: 3,
    username: "manager01",
    role: "3",
    role_name: "cashier",
    date_created: "2025-02-15T08:20:00Z",
  },
  {
    user_id: 4,
    user_name: "cashier",
    role: "2",
    role_name: "cashier",
    created_at: "2025-02-18T11:10:00Z",
  },
  {
    id: 5,
    username: "demo_user",
    role: null,                 // tests fallback "—"
    created: null,              // tests fallback "—"
  },
];

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usernameError, setUsernameError] = useState("");
  const [editUsernameError, setEditUsernameError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 15;


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0,0);
  };

  const indexOfLastItem = currentPage * usersPerPage;
  const indexOfFirstItem = indexOfLastItem - usersPerPage;
  const currentUsers = users.slice(indexOfFirstItem, indexOfLastItem);

  const isUsernameExists = (username) => {
  return users.some(
    (u) =>
      (u.username ?? u.user_name ?? "")
        .toLowerCase()
        .trim() === username.toLowerCase().trim()
  );
};
const isUsernameExistsForUpdate = (username, currentId) => {
  return users.some((u) => {
    const id = u.id ?? u.user_id;
    const existingUsername = (u.username ?? u.user_name ?? "")
      .toLowerCase()
      .trim();

    return (
      existingUsername === username.toLowerCase().trim() &&
      id !== currentId //  ignore current editing user
    );
  });
};

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    role: "2",
  });
  
  const [showPassword, setShowPassword] = useState(false);

  const [modal, setModal] = useState(false);
const [editingId, setEditingId] = useState(null);

const [editFormData, setEditFormData] = useState({
  username: "",
  role: "2",
});

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}usersapi/list`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setUsers(data);
      } else if (data?.data && Array.isArray(data.data)) {
        setUsers(data.data);
      } else if (data?.users && Array.isArray(data.users)) {
        setUsers(data.users);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);
//  useEffect(() => {
//         setLoading(true);
//         setTimeout(() => {
//             setUsers(mockdata);
//             setLoading(false);
//         }, 800);
//     }, []);

const handleChange = (e) => {
  const { name, value } = e.target;

  //  ALWAYS allow typing
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  //  Validation only sets error, never blocks typing
  if (name === "username") {
    if (!value.trim()) {
      setUsernameError("Username is required");
    } else if (isUsernameExists(value)) {
      setUsernameError("Username already exists");
    } else {
      setUsernameError("");
    }
  }
};

const handleUserCreate = async (e) => {
  e.preventDefault();

  // if (!formData.username.trim() || !formData.password.trim()) {
  //   alert("Username and password are required");
  //   return;
  // }
    if (!formData.username.trim()) {
    setUsernameError("Username is required");
    return;
  }

  if (isUsernameExists(formData.username)) {
    setUsernameError("Username already exists");
    return;
  }

  if (!formData.password.trim()) {
    alert("Password is required");
    return;
  }

  setSubmitting(true);
  try {
    const response = await fetch(`${API_BASE}usersapi/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to create user");
    }

    alert("User created successfully");
    setFormData({ username: "", password: "", role: "2" });
    setUsernameError("");
    setShowPassword(false);
    fetchUsers();
  } catch (error) {
    console.error("Error:", error);
    alert(error.message);
  } finally {
    setSubmitting(false);
  }
};
const handleEdit = (user) => {
  const id = user.id ?? user.user_id;

  setEditFormData({
    username: user.username ?? user.user_name ?? "",
    role: user.role ?? "2",
  });

  setEditingId(id);
  setModal(true);
};
const handleEditSubmit = async (e) => {
  e.preventDefault();

  if (!editFormData.username.trim()) {
    alert("Username is required");
    return;
  }
  if (isUsernameExistsForUpdate(editFormData.username, editingId)) {
    setEditUsernameError("Username already exists");
    return;
  }

  try {
    const res = await fetch(`${API_BASE}usersapi/update?user_id=${editingId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editFormData),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Failed to update user");

    alert("User updated successfully");
    setModal(false);
    setEditingId(null);
    setEditUsernameError("");
    fetchUsers();
  } catch (err) {
    alert(err.message);
  }
};
const handleCancelEdit = () => {
  setModal(false);
  setEditingId(null);
  setEditFormData({ username: "", role: "2" });
};
const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this user?")) return;

  try {
    const res = await fetch(`${API_BASE}usersapi/delete?user_id=${id}`, {
      method: "DELETE",
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Failed to delete user");

    alert("User deleted successfully");
    fetchUsers();
  } catch (err) {
    alert(err.message);
  }
};

  return (
    <div className="manage-users-container">
      <Helmet>
        <title>Manage Users</title>
      </Helmet>

      <div className="main">
        {/* LEFT */}
        <div className="left-container">
          <span className="create-user-title">
            <FontAwesomeIcon icon={faUsersGear} />
            <h3>User Management</h3>
          </span>

          <div className="create-user-container">
            <h2>Create New User</h2>

            <form onSubmit={handleUserCreate}>
              {/* USERNAME */}
              <div className="login-form-field">
                <label htmlFor="username">Username</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faUser} />
                  </span>
                  <input
                    id="username"
                    type="text"
                    name="username"
                    placeholder="Enter username"
                    value={formData.username}
                    onChange={handleChange}
                  />
                </div>
                {usernameError && (
                  <small className="error-text">{usernameError}</small>
                )}
              </div>

              {/* PASSWORD */}
              <div className="login-form-field">
                <label htmlFor="password">Password</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faLock} />
                  </span>

                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="••••••••"
                    value={formData.password}
                    onChange={handleChange}
                  />

                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    <FontAwesomeIcon
                      icon={showPassword ? faEyeSlash : faEye}
                    />
                  </span>
                </div>
              </div>

              {/* ROLE */}
              <div className="login-form-field">
                <label htmlFor="role">Role</label>
                <div className="login-input-container">
                  <select
                    id="role"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                  >
                    <option value="2">Cashier (POS Only)</option>
                    <option value="1">Admin (Full Access)</option>
                  </select>
                </div>
              </div>

              {/* SUBMIT */}
              <button type="submit" className="login-form-submit" disabled={submitting}>
                <FontAwesomeIcon icon={faPlus} /> {submitting ? "Creating..." : "Create User"}
              </button>
            </form>
          </div>
        </div>

        {/* RIGHT */}
        <div className="product-search-container">
          <span className="existing-users-header"><FontAwesomeIcon icon={faUserCheck} /><h3>Existing Users</h3></span>
        {loading ? (
  <p className="no-data-message">Loading users...</p>
) : users.length === 0 ? (
  <p className="no-data-message">No users yet. Create one using the form.</p>
) : (
  <>
    {/* ===== DESKTOP TABLE ===== */}
    <div className="user-table-wrapper user-table-desktop">
      <table className="existing-users-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Role</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.map((user) => {
            const id = user.id ?? user.user_id;
            const username = user.username ?? user.user_name ?? "—";
            const role = user.role ?? "—";
            const roleMap = {
                1: "admin",
                2: "cashier",
            };
            const role_name = roleMap[Number(role)] ?? "—";
            const created =
              user.created_at ?? user.created ?? user.date_created;

            return (
              <tr key={id}>
                <td>{username}</td>
                <td>{role_name}</td>
                <td>{created ? new Date(created).toLocaleString() : "—"}</td>
                <td className="icon-cell">
                  <span
                    className="action-icon edit"
                    onClick={() => handleEdit(user)}
                    title="Edit"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </span>

                  {role !== "1" && (
                    <span
                      className="action-icon delete"
                      onClick={() => handleDelete(id)}
                      title="Delete"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination
        currentPage={currentPage}
        totalItems={users.length}
        itemsPerPage={usersPerPage}
        onPageChange={handlePageChange}
      />
    </div>

    {/* ===== MOBILE CARDS ===== */}
    <div className="users-cards-mobile">
      {currentUsers.map((user) => {
        const id = user.id ?? user.user_id;
        const username = user.username ?? user.user_name ?? "—";
        const role = user.role ?? "—";
        const role_name = user.role_name ?? "—";
        const created =
          user.created_at ?? user.created ?? user.date_created;

        return (
          <div key={id} className="user-card">
            <div className="user-card-main">
              <span className="user-card-name">{username}</span>
              <span className="user-card-role">{role_name}</span>
            </div>

            <div className="user-card-secondary">
              <span>
                Created: {created ? new Date(created).toLocaleDateString() : "—"}
              </span>
            </div>

            <div className="user-card-actions">
              <button
                type="button"
                className="action-btn edit"
                onClick={() => handleEdit(user)}
              >
                <FontAwesomeIcon icon={faEdit} /> Edit
              </button>

              {role !== "1" && (
                <button
                  type="button"
                  className="action-btn delete"
                  onClick={() => handleDelete(id)}
                >
                  <FontAwesomeIcon icon={faTrash} /> Delete
                </button>
              )}
            </div>
          </div>
        );
      })}
      <Pagination
        currentPage={currentPage}
        totalItems={users.length}
        itemsPerPage={usersPerPage}
        onPageChange={handlePageChange}
      />
    </div>
  </>
)}
        </div>
        {modal && (
  <div className="manage-customer-modal">
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Edit User</h2>

        <form onSubmit={handleEditSubmit}>
          <table>
            <tbody>
              <tr className="login-form-field login-form-field-modal">
                <td><label>Username *</label></td>
                <td>
                  <input
                    type="text"
                    value={editFormData.username}
                     onChange={(e) => {
                      const value = e.target.value;

                      setEditFormData({ ...editFormData, username: value });

                      if (!value.trim()) {
                        setEditUsernameError("Username is required");
                      } else if (isUsernameExistsForUpdate(value, editingId)) {
                        setEditUsernameError("Username already exists");
                      } else {
                        setEditUsernameError("");
                      }
                    }}
                  />
                  {editUsernameError && (
                    <small className="error-text">{editUsernameError}</small>
                  )}
                </td>
              </tr>

              <tr className="login-form-field login-form-field-modal">
                <td><label>Role</label></td>
                <td>
                  <select
                    value={editFormData.role}
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, role: e.target.value })
                    }
                  >
                    <option value="2">Cashier</option>
                    <option value="1">Admin</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td colSpan={2}>
                  <div className="modal-buttons">
                    <button type="submit">Update</button>
                    <button type="button" onClick={handleCancelEdit}>
                      Cancel
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default ManageUsers;